function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarnevogn = function SvgBarnevogn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.03 91"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2057.01 336.462A35.623 35.623 0 0 0 2021.23 301v35.462zm-53.66 23.638a21.37 21.37 0 0 1-21.46-21.277h75.12a21.38 21.38 0 0 1-21.47 21.277zm-2.98 31.9a14.186 14.186 0 1 1 14.31-14.185A14.264 14.264 0 0 1 2000.37 392m0-23.641a9.457 9.457 0 1 0 9.54 9.456 9.51 9.51 0 0 0-9.54-9.456M2037.33 392a14.186 14.186 0 1 1 14.31-14.185A14.264 14.264 0 0 1 2037.33 392m0-23.641a9.457 9.457 0 1 0 9.54 9.456 9.51 9.51 0 0 0-9.54-9.456m-67.96-49.037a2.364 2.364 0 1 0 0 4.728 12.483 12.483 0 0 1 12.52 12.412h4.77a17.237 17.237 0 0 0-17.29-17.14",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    transform: "translate(-1966.97 -301)"
  }));
};
export default SvgBarnevogn;